<template>
  <div class="col-sm-6 col-md-4 col-xl-3">
    <div class="my-4 text-center">
      <!-- <p class="text-muted">Center modal</p> -->
      <b-button v-b-modal.modal-center variant="primary" class="xs">
        Προσθήκη</b-button
      >
      <b-modal
        id="modal-center"
        title="Προσθήκη Υπογραφής"
        centered
        hide-footer
      >
        <div class="col-lg-12">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title">Προσθήκη Υπογραφής</h4>
              <b-alert
                v-if="is_success"
                show
                dismissible
                :variant="alertVariant"
                >{{ alertMsg }}</b-alert
              >
              <p class="card-title-desc">
                Συμπληρώστε την παρακάτω φόρμα για προσθήκη Υπογραφής
              </p>
              <form class="needs-validation" @submit.prevent="submitForm">
                <div class="row">
                  <div class="col-md-6">
                    <div class="mb-3">
                      <label for="validationCustom01">Υπογραφή</label>
                      <input
                        v-model="signatureName"
                        id="validationCustom01"
                        type="text"
                        class="form-control"
                        placeholder="Υπογραφή"
                        required
                      />
                    </div>
                  </div>
                </div>

                <button class="btn btn-primary" type="submit">
                  Ολοκλήρωση
                </button>
              </form>
            </div>
          </div>
          <!-- end card -->
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
export default {
  name: "FormModal",
  data() {
    return {
      is_success: false,
      is_failure: false,
      signatureName: "",
      alertVariant: "",
      alertMsg: "",
    };
  },
  methods: {
    submitForm() {
      this.$emit("SignatureFormModal", this.signatureName);
      this.is_success = true;
      this.alertVariant = "success";
      this.alertMsg = "Υπογραφή προστέθηκε επιτυχώς";
      this.$bvModal.hide("modal-center");
    },
  },
};
</script>
